import axios from "axios";
import BreadCrumb from "Common/BreadCrumb";
import columnData from "Common/Components/ColumnData/WastForFarmer";
import { getUsername } from "Common/Components/getRoleId";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import TableContainer from "Common/TableContainer";
import { useEffect, useState } from "react";

function WastFarmer() {
  const [data, setData] = useState<any>();
  const getuserID = Number(getUsername(localStorage.getItem("app_atkey")));
  const yearId = Number(localStorage.getItem("crop_year_id"));
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const res = async () => {
      try {
        const res = await axios.get(
          `https://api.havirkesht.ir/farmers-waste-delivery/by-user/${getuserID}?crop_year_id=${yearId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        console.log(data, "dataaa");
        setData(res.data);
      } catch (error: any) {
        console.error("Error fetching data:", error);
        setErrorMessage(
          error.response
            ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
            : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
        );
      }
    };
    res();
  }, []);

  return (
    <div className="px-6">
      {" "}
      <BreadCrumb pageTitle="سهمیه تفاله  های شما" title=" هاویر کشت " />
      <div className="flex  flex-col gap-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
        {/* بخش عنوان و جستجو */}
        <div className="flex  flex-col w-full gap-3 sm:flex-row sm:items-center sm:grow">
          <h6 className="text-15 grow whitespace-nowrap">
            مجموع سهمیه تفاله ها (
            <b className="total-Employs mb-5">{data?.length}</b>)
          </h6>
          <div className="flex items-center  gap-3"></div>
        </div>
      </div>
      {data && data.length > 0 ? (
        <TableContainer
          isPagination={false}
          columns={columnData}
          isGlobalFilter={false}
          data={data}
          customnumberfortable={10}
          customPageSize={10}
          divclassName="-mx-5 overflow-x-auto"
          tableclassName="w-full whitespace-nowrap"
          theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
          thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
          tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
          PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
        />
      ) : (
        <div className="h-full flex justify-center items-center ">
          <LoadingCounter
            count={data ? 0 : 15}
            text={
              errorMessage ? errorMessage : "سهمیه  تفاله ای  برای شما ثبت نشده"
            }
          />
        </div>
      )}
    </div>
  );
}

export default WastFarmer;
